export default {
  retail: {
    breadcrumbHome: 'Faqja kryesore',
    breadcrumbSolutions: 'Zgjidhjet',
    breadcrumbCurrent: 'Tregtia dhe gastronomia',
    hero: {
      eyebrow: 'Tregtia dhe gastronomia',
      title: 'Më shumë siguri në dyqane dhe gastronomi',
      lead: 'Hyrja, arka, magazina dhe hyrja e kuzhinës – mbrojmë biznesin tuaj nga vjedhja dhe vandalizmi pa shqetësuar klientët.',
    },
    points: {
      title: 'Pikat e mbikëqyrjes për tregtinë dhe gastronominë',
      lead: 'Çdo dyqan dhe biznes gastronomik ka zonat e veta të rrezikut. Vendosim kamerat pikërisht aty ku bëjnë ndryshim.',
      items: {
        '0': { title: 'Hyrja dhe vitrina', desc: 'Pika e parë e mbikëqyrjes: kamerat në hyrje dokumentojnë kush hyn e del dhe parandalojnë që në hyrje.' },
        '1': { title: 'Zona e arkës', desc: 'Arka dhe zona e pagesës janë pika më e ndjeshme në tregti. Kamerat diskrete e sigurojnë pa shqetësuar klientët.' },
        '2': { title: 'Sipërfaqja e shitjes', desc: 'Pamje e gjithë sipërfaqes: kamerat me kënd të gjerë zbulojnë lëvizje të dyshimta midis rafteve dhe korridoreve.' },
        '3': { title: 'Magazina dhe furnizimi', desc: 'Marrja e mallrave, magazina dhe hyrjet e stafit: këtu shfaqen boshllëqe. I mbyllim.' },
        '4': { title: 'Banaku dhe hyrja e kuzhinës', desc: 'Në gastronomi, banaku dhe hyrja e kuzhinës janë zona kritike. Kamera të qëndrueshme i rezistojnë lagështisë dhe nxehtësisë.' },
        '5': { title: 'Tarraca e jashtme', desc: 'Tarraca dhe tavolinat e jashtme ftojnë hajdutët, sidomos në mbrëmje. Kamera rezistente ruajnë.' },
      },
    },
    protection: {
      eyebrow: 'Mbrojtja nga vjedhja',
      title: 'Më pak humbje inventari, më shumë siguri',
      lead: 'Vjedhjet në dyqan dhe diferencat e inventarit kushtojnë shumë çdo vit. Kamerat e vendosura mirë ulin humbjet dhe japin pamje të dobishme.',
      items: {
        '0': { title: 'Mbikëqyrja e arkës', desc: 'Pamje të qarta të arkës dhe zonës së pagesës – për dokumentim të plotë në mosmarrëveshje.' },
        '1': { title: 'Vitrinat dhe hyrjet', desc: 'Parandalim dhe sqarim te vandalizmi apo thyerja – nga vitrina te hyrja e pasme.' },
        '2': { title: 'Regjistrat e ngjarjeve', desc: 'Lëvizja, kalimi i vijës ose ngjarjet e dyerve aktivizojnë regjistrimin dhe njoftimet push.' },
      },
    },
    gastro: {
      eyebrow: 'Gastronomia',
      title: 'Teknologji e qëndrueshme për banak, kuzhinë dhe tarracë',
      lead: 'Avulli, yndyra dhe lagështia kërkojnë shumë nga teknologjia. Zgjedhim kamera që punojnë me besueshmëri në përditshmërinë gastronomike, pa u ndjerë nga mysafirët.',
      list: {
        '0': 'Mbikëqyr hyrjen e kuzhinës – vetëm staf i autorizuar',
        '1': 'Siguro banakun dhe arkën pa shqetësuar mysafirët',
        '2': 'Tarraca e jashtme nën vëzhgim në orët e mbrëmjes',
        '3': 'Dokumento furnitorët dhe furnizimin pa boshllëqe',
        '4': 'Vendos tabela informuese për mysafirët dhe stafin',
      },
      note: 'Shënim: ligjshmëria e mbikëqyrjes me video varet nga rasti. Ne ju këshillojmë, pa zëvendësuar këshillën ligjore.',
    },
    cta: {
      title: 'Biznesi juaj meriton një kuadër të sigurt',
      lead: 'Ju tregojmë pa detyrim se ku ia vlen mbikëqyrja me video dhe ku nuk është e nevojshme.',
      primary: 'Rezervoni një takim konsultimi',
      secondary: 'Zbuloni SSG Care',
    },
  },
};